import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

const Blog = () => {
  const { allMarkdownRemark } = useStaticQuery(
    graphql`
      query {
        allMarkdownRemark(
          filter: { frontmatter: { categories: { eq: "Genel" } } }
          sort: {
            fields: [frontmatter___date]
            order: DESC
          }
        ) {
          edges {
            node {
              frontmatter {
                path
                title
                date(formatString: "MMMM DD, YYYY")
                topDetail
                categories
                authorName
                authorImage {
                  childImageSharp {
                    fixed(height: 60) {
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
                featuredImage {
                  childImageSharp {
                    fixed(width: 415, height: 375) {
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  )

  const firstBlog = allMarkdownRemark.edges[0].node.frontmatter
  const { edges } = allMarkdownRemark
  return (
    <Layout>
      <SEO
        title="Blog"
        description="Future trends. Global agenda. Local dynamics. Digital world components. Marketing techniques. And much more. Click to view our blog page!"/>
      <div className="container blog">
        <div className="blog-header" style={{marginTop:-60}}>
          <h1>Latest from <br/>our blog</h1>
          <p>
          Future trends. Global agenda. Local dynamics. Digital world components. Marketing techniques. And much more.  </p>
        </div>
        <div className="blog-lastest py60">
          <div className="post col-md-12">
            <div className="col-md-5 noPadding">
              <span>Featured Article</span>
              <h2>
                <a href={firstBlog.path}>{firstBlog.title}</a>
              </h2>
              <p>{firstBlog.topDetail}</p>
              <div className="author">
                <Img
                  alt={firstBlog.authorName}
                  fixed={firstBlog.authorImage.childImageSharp.fixed}
                />
                <div className="author-name">
                  <b>{firstBlog.authorName}</b>
                </div>
              </div>
            </div>
            <div className="col-md-5 post-image">
              <a href={firstBlog.path}>
                <Img
                  fixed={firstBlog.featuredImage.childImageSharp.fixed}
                  objectFit="cover"
                  objectPosition="50% 50%"
                />
              </a>
            </div>
          </div>
          {edges.map(item => {
            const { node } = item
            const { frontmatter } = node
            return (
              <div className="post col-md-5">
                <div className="post-image">
                  <a href={frontmatter.path}>
                    <Img
                      fixed={frontmatter.featuredImage.childImageSharp.fixed}
                      objectFit="cover"
                      
                    />
                  </a>
                </div>
                <span>{frontmatter.categories}</span>
                <h2>
                  <a href={frontmatter.path}>{frontmatter.title}</a>
                </h2>
                <p>{frontmatter.topDetail}</p>
                <div className="author">
                  <b>{frontmatter.authorName}</b>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </Layout>
  )
}
export default Blog
